import { render } from "./TinyIcon.vue?vue&type=template&id=496493ed"
import script from "./TinyIcon.vue?vue&type=script&lang=js"
export * from "./TinyIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__